import { Pipe, PipeTransform } from '@angular/core';
import { UserSubType } from '../interfaces/core/core.entity';
import { LocalStorageService } from '../services/local-storage.service';

@Pipe({
	name: 'userSubType',
})
export class UserSubTypePipe implements PipeTransform {
	constructor(private ls: LocalStorageService) {}

	transform(value: string): string {
		if (!value) return '';
		const userSubTypes = this.ls.getSubTypes();
		if (!userSubTypes) return value;
		const userType = userSubTypes.find((type: UserSubType) => type.key === value);
		return userType ? userType.name : value;
	}
}
